import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "../global/global";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

interface PaginatedResponse<T> {
  data: T[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export const useGetPaginatedData = <T,>(
  url: string, 
  name: string, 
  page: number = 1, 
  perPage: number = 20,
  search?: string
) => {
  const authContext = useContext(AuthContext);

  const getData = async (): Promise<PaginatedResponse<T>> => {
    let fullUrl = `${API}${url}&paginate=true&page=${page}&per_page=${perPage}`;
    if (search && search.trim().length > 0) {
      fullUrl += `&search=${encodeURIComponent(search)}`;
    }
    
    const { data } = await axios.get(fullUrl, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authContext.token,
      },
    });
    return data;
  };

  const { data, isLoading, refetch } = useQuery([name, page, perPage, search], getData, {
    keepPreviousData: true,
  });

  return {
    data: data?.data || [],
    pagination: {
      currentPage: data?.current_page || 1,
      lastPage: data?.last_page || 1,
      perPage: data?.per_page || perPage,
      total: data?.total || 0,
    },
    isLoading,
    refetch,
  };
};
